import React, {useState, useEffect} from 'react';
import {Button, CircularProgress, Step, StepLabel, Stepper, Typography} from "@material-ui/core";
import {Form, Formik} from "formik";
import FormInitialValues from "../Checkout/FormModel/formInitialValues";
import ValidationSchema from "../Checkout/FormModel/validationSchema";
import AdviserFormModel from "../Checkout/FormModel/formModel";
import {makeStyles} from "@material-ui/core/styles";
import PersonalForm from "../Checkout/Forms/PersonalForm";
import {useQuery, gql} from "@apollo/client";
import Axios from 'axios';
import {useAuth0} from "@auth0/auth0-react";
import AdviserRegisterSuccess from "./AdviserRegisterSuccess";
import PoppinsBold from '../../../../assets/fonts/Poppins/Poppins-Bold.ttf';

const steps = ['Información Personal'];
const {formId, formField} = AdviserFormModel;

const GET_CODIGOS = gql`
query MyQuery {
  General_Localidades {
    CodPostal
    CodSancorLocalidad
    Localidad
  }
}
`;

const useStyle = makeStyles((theme) => ({
    formTitle: {
        fontFamily: "PoppinsBold",
        fontSize: "24px",
        color: "#bb0d66",
    },
    stepper: {
        padding: theme.spacing(3, 0, 5),
        alignSelf: "center"
    },
    icon: {
        fill: "#BB0D66",
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        backgroundColor: "#BB0D66",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#8a0046"
        }
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    }
}))

function _renderStepContent(step, values, localidades) {
    switch (step) {
        case 0:
            return <PersonalForm formField={formField} values={values} localidades={localidades}/>;
        default:
            return <div>Not Found</div>;
    }
}


function CheckoutAdviserRegister(props) {
    const classes = useStyle()
    const {getIdTokenClaims} = useAuth0();
    const [activeStep, setActiveStep] = useState(0);
    const [localidades, setLocalidades] = useState([]);
    const currentValidationSchema = ValidationSchema[activeStep];
    const isLastStep = activeStep === steps.length - 1;

    const [loading, setLoading] = useState(false);

    function getCodigos() {
        let options = localidadesData.General_Localidades.map(d => ({
            "value": d.CodPostal.toString() + ',' + d.CodSancorLocalidad.toString(),
            "label": '(' + d.CodPostal.toString() + ') ' + d.Localidad
        }));
        setLocalidades(options);
    };

    const {data: localidadesData} = useQuery(GET_CODIGOS, {
        fetchPolicy: "cache-first"
    });

    async function _submitForm(values, actions) {
        const claims = await getIdTokenClaims();
        const id_token = claims.__raw;
        values.cuit = parseInt(values.cuit)

        let fixCodArea = values.codArea.split("")
        if(fixCodArea[0] === "0")
            fixCodArea.shift();
        values.codArea = fixCodArea.join('');

        let url = process.env.REACT_APP_BACK_SERVER + '/registrarAsesor'

        values['phone'] = values['codArea'] + values['phone']
        Axios.post(url, values,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${id_token}`,
                }
            }).then((result) => {
                result.status === 200 && (setLoading(false))
        }).catch((error) =>
            console.log(error));

        actions.setSubmitting(false);
        setActiveStep(activeStep + 1);
    }

    function _handleSubmit(values, actions) {

        if (isLastStep) {

            setLoading(true)
            _submitForm(values, actions);

        } else {
            setActiveStep(activeStep + 1);
            actions.setTouched({});
            actions.setSubmitting(false);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
    }

    useEffect(()=>{
        if (localidadesData) {
            getCodigos()
        }
    }, [localidadesData])

    return (
        <React.Fragment>
            <div style={{padding: "30px", display: "flex", flexDirection: "column"}}>
                <h2 className={classes.formTitle} style={{alignSelf: "center"}}>Registro de Asesores</h2>
                <Stepper activeStep={activeStep} className={classes.stepper}>
                    {steps.map(label => (
                        <Step key={label}>
                            <StepLabel StepIconProps={{
                                classes: {
                                    active: classes.icon,
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <React.Fragment>
                    {activeStep === steps.length ? (
                        <AdviserRegisterSuccess loading={loading}/>
                    ) : (
                        <Formik
                            initialValues={FormInitialValues}
                            validationSchema={currentValidationSchema}
                            validateOnBlur={false}
                            onSubmit={_handleSubmit}
                        >
                            {({isSubmitting, values}) => (
                                <Form id={formId}>
                                    {_renderStepContent(activeStep, values, localidades)}

                                    <div className={classes.buttons}>
                                        {activeStep !== 0 && (
                                            <Button onClick={_handleBack} className={classes.button}>
                                                Atras
                                            </Button>
                                        )}
                                        <div className={classes.wrapper}>
                                            <Button
                                                disabled={isSubmitting}
                                                type="submit"
                                                variant="contained"
                                                className={classes.button}

                                            >
                                                Siguiente
                                            </Button>
                                            {isSubmitting && (
                                                <CircularProgress
                                                    size={24}
                                                    className={classes.buttonProgress}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    )}
                </React.Fragment>
            </div>
        </React.Fragment>
    );
}

export default CheckoutAdviserRegister;